import type { Reducer } from 'redux';

import type { SessionBootstrapFailedAction } from '../../../domains/sessionBootstrap/actions.types';

import type { Bootstrap } from './types';

export type SessionAction = SessionBootstrapFailedAction;

const initialState: Bootstrap = {
  error: null,
};

const reducer: Reducer<Bootstrap, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.BOOTSTRAP_FAILED': {
      const payloadError = action.payload.error;
      const error = typeof payloadError === 'string' ? new Error(payloadError) : payloadError;

      return {
        ...state,
        error,
      };
    }
    default:
      return state;
  }
};

export default reducer;
